module.exports = __webpack_public_path__ + "static/media/ghosia.e2acd433.webp";